// Category Action Types

// Home Page Categories (for carousel)
export const GET_HOME_CATEGORIES_REQUEST = "GET_HOME_CATEGORIES_REQUEST";
export const GET_HOME_CATEGORIES_SUCCESS = "GET_HOME_CATEGORIES_SUCCESS";
export const GET_HOME_CATEGORIES_FAILURE = "GET_HOME_CATEGORIES_FAILURE";

// All Categories (for All Categories page)
export const GET_ALL_CATEGORIES_REQUEST = "GET_ALL_CATEGORIES_REQUEST";
export const GET_ALL_CATEGORIES_SUCCESS = "GET_ALL_CATEGORIES_SUCCESS";
export const GET_ALL_CATEGORIES_FAILURE = "GET_ALL_CATEGORIES_FAILURE";

// Single Category with Subcategories
export const GET_CATEGORY_BY_SLUG_REQUEST = "GET_CATEGORY_BY_SLUG_REQUEST";
export const GET_CATEGORY_BY_SLUG_SUCCESS = "GET_CATEGORY_BY_SLUG_SUCCESS";
export const GET_CATEGORY_BY_SLUG_FAILURE = "GET_CATEGORY_BY_SLUG_FAILURE";

// Categories with Products
export const GET_CATEGORIES_WITH_PRODUCTS_REQUEST = "GET_CATEGORIES_WITH_PRODUCTS_REQUEST";
export const GET_CATEGORIES_WITH_PRODUCTS_SUCCESS = "GET_CATEGORIES_WITH_PRODUCTS_SUCCESS";
export const GET_CATEGORIES_WITH_PRODUCTS_FAILURE = "GET_CATEGORIES_WITH_PRODUCTS_FAILURE";

// Search Categories
export const SEARCH_CATEGORIES_REQUEST = "SEARCH_CATEGORIES_REQUEST";
export const SEARCH_CATEGORIES_SUCCESS = "SEARCH_CATEGORIES_SUCCESS";
export const SEARCH_CATEGORIES_FAILURE = "SEARCH_CATEGORIES_FAILURE";

// Clear/Reset Actions
export const CLEAR_CATEGORIES_ERROR = "CLEAR_CATEGORIES_ERROR";
export const RESET_CATEGORIES_STATE = "RESET_CATEGORIES_STATE"; 